/* eslint-disable max-len */
import React from 'react';

export const CheckIcon = props => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-496.000000, 0.000000)">
        <g>
          <polyline
            stroke="#FFFFFF"
            strokeWidth="2"
            points="508 23.8193359 508 64 0 64 0 12 496.790039 12"
          />
          <g transform="translate(496.000000, 0.000000)">
            <g>
              <circle fill="#FFFFFF" cx="12" cy="12" r="12" />
              <g transform="translate(5.000000, 8.000000)" fill="currentColor">
                <polygon points="12.2335029 0.239154296 13.4174702 1.3883133 5.59026761 9.73257326 0.586372643 5.73025155 1.59665912 4.42329121 5.43146554 7.49052765" />
              </g>
            </g>
            <g transform="translate(5.000000, 8.000000)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
